<template>
  <div>
    <o-field labelClass="tgbLabel" rootClass="tgbField" label="Tags">
      <o-inputitems
        v-bind="{...$props, ...$attrs}"
        v-on="$listeners"
        iconPack="fas"
        icon="tags"
        placeholder="Add a tag"
        inputClass="tgbTagsInput"
        itemClass="tgbTag"
        expanded
        closeClass="closeTag"
        :rootClass="`tgbTagsInputContainer` + (!valid ? ' critical' : '')"
        v-model="innerModel"
        @add="$emit('add');"
        @remove="$emit('remove');"
        @input="$emit('input')"
        @blur="$emit('blur')"
      >
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    </o-inputitems>
    </o-field>
    <p class="formFieldError"
        v-if="!valid"><span class="fas fa-exclamation-triangle"></span>
        Tags must be at least 2 characters and must not have special characters. <br>Remove:<span v-for="(tag, i) in invalidTag" key="i"> {{ tag }}</span>
    </p>
  </div>
</template>

<script>
const regexs = require('@tagboard/helpers/regexs');

export default {
  name: 'TgbTags',
  inheritAttrs: false,
  // todo: write some pass-through props with defaults instead of setting defaults
  // with strings in template
  props: ['label', 'value'],
  computed: {
    innerModel: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    invalidTag() {
      const found = this.innerModel.filter((hashtag) => !regexs.hashtag.test(hashtag));
      this.$emit('invalid', found.length);
      return found;
    },
    valid() {
      return !this.invalidTag.length;
    },
  },
};
</script>

<style lang="scss">
  .tgbTagsInput {
    background: transparent;
    border: none;
    padding-left: 24px;
  }
  .closeTag {
    width:20px;
    height:20px;
    color: #23CDF4
  }
</style>
